import styled from '@emotion/styled'
import { ui } from '../../utils/uiTokens'

export const Wrapper = styled.div`
    background: ${ui.card};
    border-right: 1px solid ${ui.border};
    padding: 24px 12px;
    display: flex;
    flex-direction: column;
    width: 216px;
    flex-shrink: 0;
    overflow: auto;

    ul {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    a {
        text-decoration: none;
    }

    @media screen and (max-width: 500px) {
        position: absolute;
        z-index: 2;
        left: ${(props) => (props.openSideBar ? 0 : '-232px')};
        transition: all 0.2s ease-in-out;
        height: 100%;
        box-shadow: 0 8px 24px rgba(23, 20, 26, 0.12);
    }
`

export const Main = styled.div`
    flex-grow: 2;
`

export const logo = {
    width: '132px',
    height: 'auto',
    display: 'block',
    margin: '0 0 4px 10px',
}

export const section = {
    fontSize: '12px',
    fontWeight: 600,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    lineHeight: '20px',
    margin: '0 0 4px 10px',
    color: ui.muted,
}
